<template>
  <el-popover
    placement="right"
    width="240"
    v-model="focused"
    trigger="manual"
  >
    <el-input
      class="form-item"
      :value="value"
      :disabled="disabled"
      @input="onInput"
      @focus="focused = true"
      @blur="focused = false"
      slot="reference"
      type="password"
      :maxlength="32"
      :placeholder="placeholder"
    >
      <div slot="prepend" v-if="label">
        <span>{{ label }}</span>
      </div>
    </el-input>

    <div
      v-for="(rule, i) in rules"
      :key="i"
      :class="rule.passed ? 'text-theme' : 'u-type-error'"
    >
      <i :class="rule.passed ? 'el-icon-success' : 'el-icon-error'"></i>
      {{ rule.msg }}
    </div>
  </el-popover>
</template>

<script>
import { checkPassword, isPasswordValid } from '@/utils/password'

export default {
  name: 'PasswordInput',
  props: {
    value: {
      type: String,
      default: ''
    },
    label: {
        type: String,
        default: ''
    },
    placeholder: String,
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      focused: false,
      rules: []
    }
  },
  methods: {
    onInput(val) {
      this.$emit('input', val)
      this.rules = checkPassword(val)
      this.$emit('valid', isPasswordValid(val))
    }
  },
  mounted() {
    this.rules = checkPassword(this.value)
  }
}
</script>